import { API_URLS } from "src/api/api-urls";
import useApiServices from "src/api/use-api-services";
import { filtersDefaultValues } from "src/constants/filters-default-values";
import { ForbesMainDtoType } from "src/types/platforms/forbes";
import { DashboardType } from "src/types/types";
import { useQueryParams } from "use-query-params";

const useForbesDashboardView = ({ type }: { type: DashboardType }) => {
  // #region States and hooks
  const { useGetListApi } = useApiServices();

  // Get filters default from url params if available
  const [query] = useQueryParams(filtersDefaultValues);
  // #endregion States and hooks

  // #region Services
  // Get charts data and analysis
  const { data: platformData, isLoading: isDataLoading, error } = useGetListApi<ForbesMainDtoType>({
    url: API_URLS[type].FORBES.ANALYSIS,
    parameters: {
      keyword: query.keyword,
      sentiment: query.sentiment,
      language: query.language,
      start_date: query.start_date,
      end_date: query.end_date,
    },
  });

  // #endregion Services
  return {
    isDataLoading,
    platformData,
    error,
  };
};

export default useForbesDashboardView;
